import UnreviewedImagesQuery from '@/graphql/image/UnreviewedImagesQuery.gql'

import apollo from '@/graphql'

// initial state
const state = {
  unreviewedImages: [],
}

// getters
const getters = {
  unreviewedImages: st => st.unreviewedImages,
}

// mutations
const mutations = {
  setUnreviewedImages(st, unreviewedImages) {
    state.unreviewedImages = unreviewedImages
  },
}

// actions
const actions = {
  loadUnreviewedImages({ commit }) {
    apollo.defaultClient.watchQuery({
      fetchPolicy: 'network-only',
      query: UnreviewedImagesQuery,
    }).subscribe(({ data: { unreviewedImages } }) => {
      commit('setUnreviewedImages', unreviewedImages)
    })
  },
}


export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/image/ImageList.js